import React from 'react';
import { Play, Power, Check, ChevronDown } from 'lucide-react';

export default function ControlCenter({
  isRunning, workerCount, proxyEnabled, activeScraperInfo, activeScraper,
  scrapers, scraperDropdownOpen, onScraperDropdownToggle, onScraperChange,
  onProxyToggle, onSetWorkers, onStart, onPause
}) {
  return (
    <div className="bg-gray-900 border border-cyan-500/30 rounded-xl p-4 lg:p-5">
      <h3 className="text-cyan-400 font-bold text-base lg:text-lg mb-4">CONTROL CENTER</h3>

      {/* Scraper Selection */}
      <div className="mb-4 bg-black/30 rounded-xl p-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-gray-400 text-sm">Active Scraper</span>
          </div>
          <div className="relative">
            <button
              onClick={() => !isRunning && onScraperDropdownToggle()}
              disabled={isRunning}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg font-bold text-sm transition-all ${
                isRunning
                  ? 'bg-gray-800 text-gray-600 cursor-not-allowed'
                  : 'bg-indigo-600 hover:bg-indigo-700 text-white'
              }`}
            >
              {activeScraperInfo ? `${activeScraperInfo.icon} ${activeScraperInfo.name}` : 'Garanti BBVA'}
              <ChevronDown className={`w-4 h-4 transition-transform ${scraperDropdownOpen ? 'rotate-180' : ''}`} />
            </button>
            {scraperDropdownOpen && (
              <div className="absolute right-0 top-full mt-2 w-56 bg-gray-800 border border-gray-700 rounded-xl shadow-2xl z-50 overflow-hidden">
                {scrapers.filter(s => s.enabled).map((scraper) => (
                  <button
                    key={scraper.id}
                    onClick={() => onScraperChange(scraper.id)}
                    className={`w-full px-4 py-3 text-left flex items-center gap-3 transition-all ${
                      scraper.id === activeScraper
                        ? 'bg-indigo-600/30 text-indigo-300'
                        : 'text-gray-300 hover:bg-gray-700'
                    }`}
                  >
                    <span className="text-lg">{scraper.icon}</span>
                    <div>
                      <div className="font-medium text-sm">{scraper.name}</div>
                      <div className="text-xs text-gray-500">{scraper.description}</div>
                    </div>
                    {scraper.id === activeScraper && (
                      <Check className="w-4 h-4 text-indigo-400 ml-auto" />
                    )}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
        {isRunning && (
          <p className="text-xs text-yellow-500/70 mt-2">Queue durdurulmalı scraper degistirmek icin</p>
        )}
      </div>

      {/* Proxy Toggle */}
      <div className="mb-4 bg-black/30 rounded-xl p-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="text-gray-400 text-sm">711 Proxy</span>
          {proxyEnabled ? (
            <span className="text-green-400 text-xs">● ON</span>
          ) : (
            <span className="text-red-400 text-xs">● OFF</span>
          )}
        </div>
        <button onClick={onProxyToggle} disabled={isRunning}
          className={`px-4 py-2 rounded-lg font-bold text-sm transition-all ${isRunning ? 'bg-gray-800 text-gray-600 cursor-not-allowed' : proxyEnabled ? 'bg-green-600 hover:bg-green-700 text-white' : 'bg-red-600 hover:bg-red-700 text-white'}`}>
          {proxyEnabled ? 'ON' : 'OFF'}
        </button>
      </div>

      {/* Worker Slider */}
      <div className="mb-4 bg-black/30 rounded-xl p-4">
        <div className="flex justify-between items-center mb-2">
          <span className="text-gray-400 text-sm">Processing Limit</span>
          <span className="text-cyan-400 font-bold text-lg">{workerCount}x</span>
        </div>
        <input type="range" min="0" max="500" step="10" value={workerCount}
          onChange={(e) => onSetWorkers(parseInt(e.target.value))}
          className="w-full h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer accent-cyan-500" />
        <div className="flex justify-between text-xs text-gray-600 mt-1">
          <span>0</span><span>125</span><span>250</span><span>375</span><span>500</span>
        </div>
      </div>

      {/* Start / Pause */}
      <div className="grid grid-cols-2 gap-3 mb-4">
        <button onClick={onStart} disabled={isRunning}
          className={`px-6 py-3 lg:py-4 rounded-xl font-bold transition-all flex items-center justify-center gap-2 ${
            isRunning ? 'bg-gray-800 text-gray-600 cursor-not-allowed'
              : 'bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white shadow-lg shadow-green-600/20'
          }`}>
          <Play className="w-5 h-5" /> START ({workerCount}x)
        </button>
        <button onClick={onPause} disabled={!isRunning}
          className={`px-6 py-3 lg:py-4 rounded-xl font-bold transition-all flex items-center justify-center gap-2 ${
            !isRunning ? 'bg-gray-800 text-gray-600 cursor-not-allowed'
              : 'bg-gradient-to-r from-yellow-600 to-orange-600 hover:from-yellow-700 hover:to-orange-700 text-white'
          }`}>
          <Power className="w-5 h-5" /> PAUSE
        </button>
      </div>

      {/* Quick Worker Buttons */}
      <div className="grid grid-cols-5 gap-2">
        {[50, 100, 150, 200, 250].map(count => (
          <button key={count} onClick={() => onSetWorkers(count)}
            className={`px-2 py-2 rounded-lg font-bold text-sm transition-all ${
              workerCount === count ? 'bg-cyan-600 text-white' : 'bg-gray-800 text-gray-400 hover:bg-gray-700'
            }`}>
            {count}x
          </button>
        ))}
      </div>
    </div>
  );
}
